import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import LoadingScreen from "./components/LoadingScreen";
import Home from "./pages/Home";
import About from "./pages/About";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";
import ProductPage from "./pages/ProductPage";
import Certifications from "./pages/Certifications";
import "./index.css";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Hide loader once window has fully loaded (or after 1.8s ceiling)
    const done = () => setLoading(false);
    const timer = setTimeout(done, 1800);

    if (document.readyState === "complete") {
      setTimeout(done, 900);
    } else {
      window.addEventListener("load", () => setTimeout(done, 400));
    }

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <LoadingScreen visible={loading} />
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/mushroom" element={<ProductPage productId="mushroom" />} />
            <Route path="/saffron" element={<ProductPage productId="saffron" />} />
            <Route path="/poultry" element={<ProductPage productId="poultry" />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/certifications" element={<Certifications />} />
            <Route path="*" element={<Home />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
